<div class="content-autoheight">
    <input #InputFile type="file" id="uploadfile" class="custom-file-input" [accept]="accept" [attr.single]="multiple ? null : ''" [attr.multiple]="multiple ? '' : null"  (change)="uploadFiles($event)">
    <label [ngClass]="'custom-file-input-label'"  for="uploadfile" appUploadFile (onFileDropped)="uploadFiles($event)">
        <svg class="icon-upload">
          <use xlink:href="#hs-upload"></use>
        </svg>
        {{textoFondo}}
    </label>
</div>
